<script setup>
import {  ref, defineEmits, watch, computed, reactive } from "vue";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";

const props = defineProps(["audioName"]);

const listenStore = useListenConfigStore();

const imageMap = computed(() => imageConfig[theme.value]);

const theme = computed(() => listenStore.theme);

const $emits = defineEmits(["getDuration", "play"]);

const ossUrl = reactive("https://ydl-static.oss-cn-hangzhou.aliyuncs.com/grammar_content/"); //音频前缀路径

const audioSrc = ref(""); //完整音频连接

const duration = ref("00:00"); //音频总时长

const audioRef = ref(); //播放器

const currentDuration = ref("00:00"); //当前已播放时长

const paused = ref(true);

const ended = ref(false);

const isMoveIn = ref(false); //是否在移动中

const progressRef = ref(); //进度条

const currentProgressRef = ref();

const circleRef = ref();

watch(
  () => props.audioName,
  (newval) => {
    if (newval) {
      audioSrc.value = `${ossUrl}${props.audioName}`;
    }
  }
);

watch(()=>listenStore.playbackRate,()=>{
  audioRef.value.playbackRate = listenStore.playbackRate;
})

watch(()=>listenStore.volume,()=>{
  audioRef.value.volume = parseInt(listenStore.volume) / 100;
})


//音频在可以播放时触发
const getDuration = () => {
  duration.value = timeFormat(audioRef.value.duration);
  $emits("getDuration", audioRef.value.duration);

  audioRef.value.addEventListener("play", () => {
    ended.value = false;
    paused.value = false;
    audioRef.value.volume = parseInt(listenStore.volume) / 100;
  });
  audioRef.value.addEventListener("ended", () => {
    currentProgressRef.value.style.width = "0px";
    ended.value = true;
    paused.value = true;
    currentDuration.value = timeFormat(0);
  });
  audioRef.value.addEventListener("pause", () => {
    paused.value = true;
    ended.value = false;
  });
};

//将单位为秒的的时间转换成mm:ss的形式
const timeFormat = (number) => {
  let minute = parseInt(String(number / 60));
  let second = parseInt(String(number % 60));
  minute = minute >= 10 ? minute : "0" + minute;
  second = second >= 10 ? second : "0" + second;
  return minute + ":" + second;
};

const moveX = ref(0);
//进度条发生变化时触发
const updateTime = () => {
  if (!progressRef.value) return;
  currentDuration.value = timeFormat(audioRef.value.currentTime);
  //如果不是正在移动 和 没有暂停播放就执行
  if (!isMoveIn.value || !audioRef.value.paused) {
    //设置当前时间
    moveX.value =
      progressRef.value.clientWidth * (audioRef.value.currentTime / audioRef.value.duration);
    //播放时更新距离
    currentProgressRef.value.style.width = `${moveX.value}px`;
    //circleRef.value.style.left = `${moveX - (circleRef.value.clientWidth / 2) - 8}px`;
  }
};

const handlePauseOrPlay = () => {
  setTimeout(() => {
    audioRef.value.paused
      ? audioRef.value.play().then((_) => {
          $emits("play");
          audioRef.value.volume = parseInt(listenStore.volume) / 100;
          audioRef.value.playbackRate = listenStore.playbackRate;
        })
      : audioRef.value.pause();
    clearTimeout();
  }, 500);
};

defineExpose({
  audioRef,
  currentProgressRef
});
</script>

<template>
  <div class="audio-container">
    <img
      :src="paused ? imageMap.audio_play : imageMap.audio_paused"
      alt=""
      @click="handlePauseOrPlay()"
    />
    <div class="audio-box">
      <audio
        @canplay="getDuration"
        controls
        @timeupdate="updateTime"
        v-show="false"
        ref="audioRef"
        :src="audioSrc"
      />
      <div>
        <div class="progress" ref="progressRef" @click="clickProgress" @mouseup="handleMouseup">
          <div class="currentProgress" ref="currentProgressRef">
            <span class="circle" ref="circleRef" @mousedown="handleMousedown"></span>
          </div>
        </div>
        <div class="time">
          <span class="startTime">{{ currentDuration }}</span>
          <span class="endTime">{{ duration }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
.audio-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  margin-top: 0.4rem;
  img {
    width: 2rem;
    height: 2rem;
  }
  #audio {
    width: 18rem;
    height: 0.7rem;
  }
  .audio-box {
    flex: 1;
    margin-top: 0.6rem;
  }
}
.progress {
  height: 0.25rem;
  border-radius: 3px;
  margin-bottom: 5px;
  width: 100%;
  background-color: #e3e4e6;
  cursor: pointer;

  .currentProgress {
    position: relative;
    height: 100%;
    width: 0;
    background-color: var(--audio-point-bg);
    border-radius: 3px;
    transition: all linear 0.4s;
    .circle {
      position: absolute;
      right: -10px;
      top: -4px;
      display: inline-block;
      width: 0.76rem;
      height: 0.76rem;
      border-radius: 50%;
      border: 2px solid #ffffff;
      background-color: var(--audio-point-bg);
      box-shadow: 0 0 10px #ccc;
      transition: all linear 0.4s;
    }
  }
}
.time {
  display: flex;
  justify-content: space-between;
  color: #898c90;
  font-size: 0.64rem;
  margin-left: -5px;
  margin-top: 0.25rem;
}
</style>
